// src/pages/TplinkTapoPower.jsx
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TplinkTapoPower() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>Tapo Smart Power | TP-Link | SeguraTech</title>
        <meta
          name="description"
          content="Explore TP-Link Tapo smart power solutions including Smart Plugs and Smart Power Strips for convenient, energy-efficient control of your home devices."
        />
        <meta property="og:title" content="Tapo Smart Power | TP-Link | SeguraTech" />
        <meta
          property="og:description"
          content="TP-Link Tapo Smart Plugs and Power Strips offer effortless control, automation, and energy monitoring for modern homes."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.seguratech.co.uk/tplink/tapo-power"
        />
        <meta property="og:image" content="/tplink-logo.png" />
      </Helmet>

      {/* Hero Section */}
      <section className="max-w-5xl mx-auto px-4 py-20 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold text-[#C6A564] mb-6">
          Tapo Smart Power
        </h1>
        <p className="text-lg text-white/80 max-w-3xl mx-auto">
          Intelligent energy management starts here. TP-Link’s Tapo power
          range gives you smarter ways to control, protect, and monitor
          your connected devices.
        </p>
      </section>

      {/* Feature Boxes */}
      <section className="max-w-6xl mx-auto px-4 pb-24 grid md:grid-cols-2 gap-10 text-center">
        {/* Box 1: Smart Plugs */}
        <Link
          to="/tplink/smart-plugs"
          className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition block"
        >
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">
            Smart Plugs
          </h3>
          <p className="text-white/80">
            Turn any device into a smart one. Tapo Smart Plugs allow
            remote control, scheduling, and voice activation for
            effortless energy management through the Tapo app.
          </p>
        </Link>

        {/* Box 2: Smart Power Strips */}
        <Link
          to="/tplink/smart-power-strips"
          className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition block"
        >
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">
            Smart Power Strips
          </h3>
          <p className="text-white/80">
            Control multiple devices from one outlet. Tapo Power Strips
            feature surge protection, energy monitoring, and smart
            scheduling for reliable and safe power control.
          </p>
        </Link>
      </section>

      {/* Back Link */}
      <div className="text-center pb-16">
        <Link
          to="/tplink"
          className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
        >
          ← Back to TP-Link Overview
        </Link>
      </div>
    </div>
  );
}
